<template>
  <div class="404">
    <div class="container-fluid">
      <div class="mt-5">
        <h1><i class="far fa-fw fa-meh mr-4"></i> Error 404</h1>
        <p class="lead">
          The page you requested could not be found.
        </p>
        <hr class="my-4">
        <p class="lead">
          <router-link class="btn btn-primary btn-lg" :to="{ path: '/' }">
            <i class="fa fa-fw fa-home"></i> Return home
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data: function () {
    return {
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue